import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { NotificationState } from './notification.slice';

const selectSelf = (state: RootState) => state;
const getNotificationState = createSelector(selectSelf, (state) => state.notification);

const getNotifications = createSelector(
  getNotificationState,
  (state: NotificationState) => state.notifications,
);

export const notificationQuery = {
  getNotifications,
};
